<template lang="html">

  <div>
    <div v-if="!isSignedIn">
      <p>Du er ikke logget ind. Klik her for at logge ind</p>
      <div class="">
        <div class="g-signin2 loginbutton" data-longtitle="true" data-onsuccess="onSignIn"></div>
      </div>

    </div>

  </div>

</template>

<script>


 export default {
  name: 'Login',
  props: {
    isSignedIn: Boolean
  },
  created: function () {
    window.vm.loginComponent = this;
  },
  methods: {
    onSignIn: function(googleUser) {
      this.$emit('signed-in', googleUser);
    },
  }

}


</script>

<style lang="css" scoped>
.loginbutton {
  margin: auto;
  display: inline-block;
}


</style>
